import { DownOutlined } from '@ant-design/icons';
import { Button, Grid } from 'antd';
import { debounce } from 'lodash';
import { FC, useEffect, useRef, useState } from 'react';
import { PaymentInstrument } from '../../../generated';
import { Country } from '../../../types/country';
import { ChatMessage } from './chat-message';
import { CaseData, CaseMessage } from './messages';

interface ChatMessagesProps {
  applicantId: any;
  paymentInstrument: PaymentInstrument;
  country: Country[];
  cyberSourcePublicKey: string;
  data: CaseData
  isAdmin: boolean;
  onSave: (data: { id: string; messages: { id: string; embedding: string; }[] }) => Promise<void>;
  startPollingMessages: (interval: number) => void;
  pollingMessagesData: { data: { id: string, messages: { id?: string; sentBy?: string; message?: string; embedding?: string }[] }};
  stopPollingMessages: () => void;
  caseId: string;
  transactions: any;
}
export const ChatMessages: FC<ChatMessagesProps> = (props) => {
  const [display, setDisplay] = useState<boolean>(false);

  const divRef = useRef<HTMLDivElement>(null);

  const handleScroll = debounce(() => {
    if (divRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = divRef.current;
      const scrollableHeight = scrollHeight - clientHeight;
      const scrolledPercentage = scrollTop / scrollableHeight;
      if (scrolledPercentage < 0.7) {
        setDisplay(true);
      } else {
        setDisplay(false);
      }
    }
  }, 50);

  const scrollToBottom = () => {
    const div = divRef.current;
    if (div) {
      div.scrollTop = div.scrollHeight;
    }
  };

  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;

  useEffect(() => {
    scrollToBottom();
  }, [props.data]);

  return (
    <div
      style={{
        gridColumn: 1,
        width: isMobile ? '100%' : '75%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        borderRadius: '8px',
        marginBottom: isMobile ? "calc(5%)" : "calc(1%)",
      }}
      ref={divRef}
      onScroll={handleScroll}
    >
      {props.data.messages.map((message: CaseMessage) => {
        return (
          <ChatMessage
            key={message.id}
            id={message.id}
            onSave={props.onSave}
            startPollingMessages={props.startPollingMessages}
            pollingMessagesData={props.pollingMessagesData}
            stopPollingMessages={props.stopPollingMessages}
            sentBy={typeof message.sentBy === 'string' ? message.sentBy : ''}
            message={typeof message.message === 'string' ? message.message : ''}
            embedding={message.embedding}
            createdAt={message.createdAt}
            isAdmin={props.isAdmin}
            caseId={props.caseId}
            lastName={props.data.applicant.lastName}
            restOfName={props.data.applicant.restOfName}
            transactions={props.transactions}
            paymentInstrument={props.paymentInstrument}
            applicantId={props.applicantId}
            country={props.country}
            cyberSourcePublicKey={props.cyberSourcePublicKey}
          />
        );
      })}
      {display && (
        <Button
          onClick={scrollToBottom}
          size={'small'}
          style={{
            position: 'fixed',
            borderRadius: '8px',
            marginRight: 10,
            right: 30, 
            zIndex: 5,
            marginTop:"-10px",
            color: 'black',
            background: '#D3D3D380'
          }}
        >
          Return to Bottom
          <DownOutlined />
        </Button>
      )}
      <div id="bottom"></div>
    </div>
  );
};
